import * as THREE from "three";

import Garden from '../../Garden';
import Bloom from '../Bloom';
import Stem from "../Stem";
import Flower from "../Flower";

export class ArrangementView extends THREE.Group implements GardenView {
    maxFlowers: number = 0;
    flowerCount: number = 0;

    flowers: Array<Flower> = [];

    constructor() {
        super();
        this.generate();
    }

    generate() {
        console.log("Generating garden...");

        this.flowers.forEach(flower => flower.destroy());

        this.remove(...this.flowers);

        this.maxFlowers = 64;
        this.flowerCount = 0;
    }

    generateFlower() {

        // console.log("New flower");

        const shootPreset: ShootPreset = {
            id: Math.random().toString(),
            shootCount: 1,
            lengthSegments: 64,

            materialPreset: {
                shootTextureIndex: 0,
                uniforms: {
                    shootTextureColorA: { value: new THREE.Color(.25, .5, .25) },
                    shootTextureColorB: { value: new THREE.Color(1, 1, .5) },
                },
            },

            pathFunction: () => {

                let width = 2 + Math.random() * 6;

                let path = new THREE.CatmullRomCurve3([
                    new THREE.Vector3(0, 0, 0),
                    new THREE.Vector3(.25 * Math.random(), .1, 0),
                    new THREE.Vector3(width / 2. * Math.random(), 4 + (Math.random() * 8), 0),
                    new THREE.Vector3(width, 4 + (Math.random() * 12), 0)
                ],
                    false, "catmullrom", .5
                );

                return path;
            },
            maxWidth: .075,
            maxHeight: .075,
            getNormalOffset(lengthProgress, widthProgress) {
                return Math.sin(widthProgress * Math.PI);
            },

            getBinormalOffset(lengthProgress, widthProgress) {
                return Math.cos(widthProgress * Math.PI);
            },
        }

        let stem = new Stem(shootPreset);
        stem.material.uniforms.progress.value = 0;

        let positionB = stem.geometry.path.getPointAt(.99);
        let positionA = stem.geometry.path.getPointAt(1);

        var lookPoint = new THREE.Vector3().subVectors(positionA, positionB).add(positionA);

        let preset = Garden.Presets[Math.floor(Math.random() * Garden.Presets.length)];
        let bloom = new Bloom(preset);

        bloom.position.copy(positionA);
        bloom.lookAt(lookPoint);
        bloom.rotateX(Math.PI / 2);

        bloom.reset();

        let flower = new Flower(stem, bloom);
        flower.rotation.y = this.flowerCount / this.maxFlowers * 2 * Math.PI;

        flower.grow(
            500 + Math.random() * 2000,
            500 + Math.random() * 200
        );

        this.add(flower);
        this.flowers.push(flower);


        this.flowerCount++;
    }

    update(time) {
        if (this.flowerCount < this.maxFlowers) {
            this.generateFlower();
        }

        this.flowers.forEach((flower) => {
            flower.update(time);
        })
    }
}